import React, {useState} from 'react';
import {FormGroup, Grid, Typography, withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TowLine from '../../components/Text/TwoLine';
import Paper from '@material-ui/core/Paper';
import FormCheck from '../../components/Form/FormCheck';
import ProjectStatusText from '../../components/Project/ProjectStatusText';
import {
    withPaginator,
    Pagination
} from '../../components/Pagination';
import FormaterDate from '../../components/Formater/Date';
import TableRowClickable from '../../components/Form/TableRowClickable';
import TableCellSortable, {xOrder} from "../../components/Form/TableCellSortable";
import SearchForm from "../../components/Project/SearchForm";
import EllipsisWithTooltip from "../../components/Formater/EllipsisWithTooltip";
import Tooltip from "@material-ui/core/Tooltip";
import FormRadio from "../../components/Form/FormRadio";
import moment from "moment";
import TableFooter from "@material-ui/core/TableFooter";
import DialogSelector from "../../components/Project/Dialogs/DialogSelector";
import FormHelperText from "@material-ui/core/FormHelperText";
import Button from "@material-ui/core/Button";

const ProjectsIndex = ({classes, items: projects, showClosed, closedStatusIds, search, months, uploadConfig, closedStates}) => {

    // empty projects
    projects = projects ?? [];

    const {column, order, filter, month, status} = search;
    const paramsQuery = (filter ? '&filter=' + filter + ( status ? '&status=' + status : '' ): '');
    let searchQuery = `/project?`;
    if (column) {
        searchQuery += '&column=' + column;
    }
    if (order) {
        searchQuery += '&order=' + order;
    }

    const [open, setOpen] = useState(false);
    const [type, setType] = useState('')
    const handleOpen = (type) => {
        setOpen(true);
        setType(type);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const [selectedValue, setSelectedValue] = useState(filter ? 'filter' : months ? 'month' : showClosed ? 'closed' : 'open');
    const [viewMonth, setViewMonth] = useState( month ? month : null );

    const viewOptions = [
        {label:i18n.get('deficiency.view.month'),value:'month'},
        {label:i18n.get('deficiency.view.open'),value:'open'},
        {label:i18n.get('deficiency.view.closed'),value:'closed'},
        filter ? {label: i18n.get('deficiency.view.filter'), value:'filter' } : null ,
    ];

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        let route = '';

        switch(event.target.value) {
            case 'open': route = '?closed=0'; break;
            case 'closed': route = '?closed=1'; break;
            case 'month': route = '/month'; break;
            // should show all deficiencies also with closed
            case 'all': route = '/all'; break; // not implemented yet

        }
        window.location.href = '/project' + route;
    };

    const currentMonth = viewMonth || null;
    const nextMonth = viewMonth && months && months[months.indexOf(viewMonth) - 1];
    const prevMonth = viewMonth && months && months[months.indexOf(viewMonth) + 1];
    const firstMonth = months && months[0];
    const lastMonth = months && months[months.length - 1];
    const totalMonths = months && months.length;
    const currentView = viewMonth && months && months.indexOf(viewMonth) + 1;

    const [params,setParams] = useState({ status: status ? status.split(',').map( id => parseInt(id) ) : [] });
    const handleIncludingStatus = (e) => {
        const id = parseInt( e.target.id.replace('s','') );
        let status = params.status;
        const idx = status.indexOf(id);
        idx > -1
            ? status.splice(idx, 1)
            : status.push(id);
        setParams({...params,status: status });
    };

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('project.deficiency.plural')}
                subtitle={''}
                orientation={'vertical'}

                items={[
                    {
                        icon: 'add',
                        text: i18n.get('deficiency.add'),
                        href: `/project/create`,
                        size: 'small',
                    },
                    {
                        icon: 'add',
                        text: i18n.get('deficiency.add_grace_period'),
                        type: 'button',
                        size: 'small',
                        onClick: () => handleOpen('grace_period'),
                    },
                    {
                        icon: 'add',
                        text: i18n.get('deficiency.add_defect_eliminated_note'),
                        type: 'button',
                        size: 'small',
                        onClick: () => handleOpen('defect_eliminated')
                    },
                ]}
            />
            <SearchForm url={searchQuery} {...search} {...params}>
                <Grid item xs={12} sm={12} md={5}>
                    <FormHelperText>{i18n.get('project.include_search')}</FormHelperText>
                    <FormGroup row>
                        {closedStates && closedStates.map((state) => {
                            return (
                                <FormCheck
                                    name={'status-' + state.id}
                                    id={'s' + state.id}
                                    key={state.id}
                                    label={state.name || ''}
                                    onChange={handleIncludingStatus}
                                    value={ params.status.includes(state.id) }
                                />
                            );
                        })}
                    </FormGroup>
                </Grid>
            </SearchForm>
            <Paper className={classes.paper}>
                <Grid container direction={'row'} justify={ months ? 'space-between' : 'flex-end' }>
                    {months && (
                        <Grid item xs style={{paddingTop:7}}>
                            <Typography
                                variant={'h5'}
                                color={"primary"} subtitle={''}>
                                {moment(currentMonth + '-01').locale('de').format('MMMM YYYY')}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                {i18n.get('deficiency.recorded_number',{number:projects.length})}
                            </Typography>
                        </Grid>
                    )}
                    {filter && projects.length > 0 &&
                        <Grid item xs style={{paddingTop:7}}>
                            <Button
                                component={'a'}
                                type={'button'}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => handleOpen('render_pdf')}
                            >
                                {i18n.get('project.render_pdf')}
                            </Button>
                        </Grid>
                    }
                    <Grid item xs={12} sm={8}>
                        <FormRadio
                            label={'list_projects'}
                            name={'list_projects'}
                            value={selectedValue}
                            options={viewOptions}
                            onChange={handleChange}
                            row
                            style={{margin:0}}
                        />
                    </Grid>

                </Grid>

                <Table className={classes.list} style={{ tableLayout: 'fixed' }}>
                    {projects && projects.length > 0 && (
                        <React.Fragment>
                            <TableHead>
                                <TableRow>
                                    <TableCellSortable
                                        action={`?column=number_internal&order=${xOrder(order)}` + paramsQuery}
                                        active={column === 'number_internal'}
                                        order={order}
                                    >
                                        {i18n.get('deficiency.number')}
                                    </TableCellSortable>
                                    <TableCell style={{ width:'fit-content' }}>
                                        {i18n.get('project.deficiency.cost_center')}
                                    </TableCell>
                                    <TableCellSortable
                                        action={`?column=name&order=${xOrder(order)}` + paramsQuery}
                                        active={column === 'name'}
                                        order={order}
                                        style={{width:'25%'}}
                                    >
                                        {i18n.get('deficiency.name')}
                                    </TableCellSortable>
                                    <TableCellSortable
                                        action={`?column=status_id&order=${xOrder(order)}` + paramsQuery}
                                        active={column === 'status_id'}
                                        order={order}
                                    >
                                        {i18n.get('deficiency.status')}
                                    </TableCellSortable>
                                    <TableCellSortable
                                        action={`?column=reminder&order=${xOrder(order)}` + paramsQuery}
                                        active={column === 'reminder'}
                                        order={order}
                                    >
                                        {i18n.get('project.reminder')}
                                    </TableCellSortable>
                                    <TableCell scope={'col'}>
                                        {i18n.get('project.deficiency.date.first_grace_period')}
                                    </TableCell>
                                    <TableCell scope={'col'}>
                                        {i18n.get('project.deficiency.date.second_grace_period')}
                                    </TableCell>
                                    <TableCell scope="col">{i18n.get('invoice.actions')}</TableCell>
                                    {/*<TableCell scope="col">{i18n.get('site-journal.site_journal')}</TableCell>*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {projects.map((project, idx) => (
                                    <TableRowClickable key={`project_`+idx}>
                                        <TableCell>
                                            <Typography component={'h6'}>
                                                {project.number_internal}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {(project.project_building &&
                                            project.project_building.building &&
                                            project.project_building.building.cost_center) && (
                                                <Typography component="h6">
                                                    <Tooltip title={project.project_building.building.cost_center.name}>
                                                        <span>{project.project_building.building.cost_center.number}</span>
                                                    </Tooltip>
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell style={{maxWidth: '25%'}}>
                                            <Typography component={'h6'}>
                                                <EllipsisWithTooltip >
                                                    {project.name}
                                                </EllipsisWithTooltip>
                                            </Typography>
                                            {/*<TowLine*/}
                                            {/*    sub={project.number_internal}*/}
                                            {/*/>*/}
                                        </TableCell>
                                        <TableCell >
                                            <ProjectStatusText status={project.status} size="small" />
                                        </TableCell>
                                        <TableCell>
                                            <Typography component={'h6'}>
                                                {project.reminder && (<FormaterDate value={project.reminder} />)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography component={'h6'}>
                                                {project.first_grace_period && (<FormaterDate value={project.first_grace_period} />)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography component={'h6'}>
                                                {project.second_grace_period && (<FormaterDate value={project.second_grace_period} />)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell onClick={e => { e.stopPropagation('all'); }}>

                                            {window.can('projects.view') && (
                                                <IconButton
                                                    component="a"
                                                    href={`/project/${project.id}`}
                                                >
                                                    <Icon>find_in_page</Icon>
                                                </IconButton>
                                            )}

                                            {window.can('projects.update') && (
                                                <IconButton
                                                    component="a"
                                                    href={`/project/${project.id}/edit`}
                                                >
                                                    <Icon>edit</Icon>
                                                </IconButton>
                                            )}

                                            {/*<DeleteButton*/}
                                            {/*    confirmMessage={i18n.get('invoice.delete.confirm')}*/}
                                            {/*    successMessage={i18n.get('invoice.delete.success')}*/}
                                            {/*    errorMessage={i18n.get('invoice.delete.error')}*/}
                                            {/*    href={`/project/${invoice.id}`}*/}
                                            {/*/>*/}
                                        </TableCell>
                                    </TableRowClickable>
                                ))}
                            </TableBody>
                        </React.Fragment>
                    )}

                    { months
                        ? (
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={7} style={{paddingTop:10}} align={'right'} className={classes.paginator}>
                                        <span>
                                            { i18n.get('deficiency.paginator',
                                                {current:currentView,total:totalMonths} )
                                            }
                                        </span>
                                        <IconButton
                                            component={'a'}
                                            onClick={() =>{} }
                                            disabled={currentMonth === firstMonth}
                                            href={firstMonth && '/project/month/' + firstMonth}
                                        >
                                            <Icon>first_page</Icon>
                                        </IconButton>

                                        <IconButton
                                            component={'a'}
                                            onClick={() =>{} }
                                            disabled={!nextMonth}
                                            href={nextMonth && '/project/month/' + nextMonth}
                                        >
                                            <Icon>keyboard_arrow_left</Icon>
                                        </IconButton>

                                        <IconButton
                                            component={'a'}
                                            onClick={() =>{} }
                                            disabled={!prevMonth}
                                            href={prevMonth && '/project/month/' + prevMonth}
                                        >
                                            <Icon>keyboard_arrow_right</Icon>
                                        </IconButton>

                                        <IconButton
                                            component={'a'}
                                            onClick={() =>{} }
                                            disabled={currentMonth === lastMonth}
                                            href={lastMonth && '/project/month/' + lastMonth}
                                        >
                                            <Icon>last_page</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        ) : (<Pagination colSpan={7} classes={{spacer: "none"}}/>) }
                </Table>
            </Paper>

            <DialogSelector
                type={type}
                open={open}
                handleClose={handleClose}
                closedStatusIds={closedStatusIds}
                uploadConfig={uploadConfig}
                data={{filter,projects:[...projects]}}
            />

        </Layout>

    );
};

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {

        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
    paginator: {

        '& a': {
            marginLeft: theme.spacing.unit * 2.5,
        }
    }
});

export default withStyles(styles)(
    withPaginator('projects')(ProjectsIndex)
);
